import { render, staticRenderFns } from "./SocialMediaPlatforms.vue?vue&type=template&id=778a9616&"
import script from "./SocialMediaPlatforms.vue?vue&type=script&lang=js&"
export * from "./SocialMediaPlatforms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports